import { render, staticRenderFns } from "./NudeLayout.vue?vue&type=template&id=ce6720f0"
import script from "./NudeLayout.vue?vue&type=script&lang=js"
export * from "./NudeLayout.vue?vue&type=script&lang=js"
import style0 from "./NudeLayout.vue?vue&type=style&index=0&id=ce6720f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports